import ServiceBase from "base/baseService"

export default class TipoListaCestNcmService extends ServiceBase {

    title = "Tipo de lista de CEST/NCM"
    pluralTitle = "Tipos de listas de CEST/NCM"
    url = '/cadastro/fiscal/tipolistacestncm'
    frontUrl = '/cadastro/fiscal/tipolistacestncm'
    frontUrlList = '/cadastro/fiscal/tipolistacestncmlist'
    primaryKey = 'codigo_tlcn'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        data.descricao_tlcn = data?.descricao_tlcn || ''

        return data
    }

    prepareToSave({ data }) {
        return data
    }

}

